<template>
    <div>
        <a-spin :spinning="spinning">
        <a-form-model
                ref="email"
                :model="email"
                v-bind="formItemLayoutWithOutLabel"
        >
            <a-row  class="tit">
                <a-col :span="2">
                </a-col>
                <a-col :span="10">
                    <p >Google开户信息发送到</p>
                </a-col>
            </a-row>
            <a-form-model-item
                    v-for="(google, index) in email.google"
                    :key="google.key"
                    v-bind="index === 0 ? formItemLayout : {}"
                    :label="index === 0 ? '邮箱' : ''"
                    :prop="'google.' + index + '.email'"
                    :help="formErr['google'][index]"
                    :validateStatus='!formErr.google[index]||formErr.google[index]==""?"":"error"'
                    :rules="[ {validator:(rule, value, callback)=>{validator2(rule, value, callback,'')}}]"
            >
<!--                :rules="[{ required: true, message: '请输入邮箱 ', trigger: 'blur', },{validator:(rule, value, callback)=>{validator2(rule, value, callback,'')}}]"-->
                 <a-input
                        @change="(e) => { formErr['google'][index]=''}"
                        @blur="(e) => {  google.email= e.target.value.trim() }"
                        v-model="google.email"
                        style="width: 60%; margin-right: 8px"
                />
                <a-icon type="plus"  @click="addDomain('google',1)"  v-if="index == 0"/>
<!--                <a-button type="dashed" style="width:30px;float: right" >-->
<!--                    <a-icon type="plus" /> 添加邮箱-->
<!--                </a-button>-->
                <a-icon
                        v-if="index != 0&&email.google.length > 1"
                        class="dynamic-delete-button"
                        type="minus"
                        :disabled="email.google.length === 1"
                        @click="removeDomain('google',google)"
                />
            </a-form-model-item>
            <a-form-model-item v-bind="formItemLayoutWithOutLabel" >
<!--                v-if="email.google.length<5 "-->

            </a-form-model-item>

            <a-row  class="tit" style="margin-top:80px">
                <a-col :span="2">
                </a-col>
                <a-col :span="10">
                    <p >Facebook开户信息发送到</p>
                </a-col>
            </a-row>

            <a-form-model-item
                    v-for="(facebook, index) in email.facebook"
                    :key="facebook.key"
                    v-bind="index === 0 ? formItemLayout : {}"
                    :label="index === 0 ? '邮箱' : ''"
                    :prop="'facebook.' + index + '.email'"
                    :help="formErr['facebook'][0]"
                    :validateStatus='!formErr.google[index]||formErr.google[index]==""?"":"error"'
                    :rules="[{validator:(rule, value, callback)=>{validator2(rule, value, callback,'')}}]"
            >
<!--                :rules="[{ required: true, message: '请输入邮箱 ', trigger: 'blur', },{validator:(rule, value, callback)=>{validator2(rule, value, callback,'')}}]"-->
                <a-input
                        @change="(e) => { formErr['facebook'][index]=''}"
                        @blur="(e) => {  facebook.email= e.target.value.trim() }"
                        v-model="facebook.email"
                        style="width: 60%; margin-right: 8px"
                />
                <a-icon type="plus"  @click="addDomain('facebook',1)"  v-if="index == 0"/>
                <a-icon
                        v-if="index != 0&&email.facebook.length > 1"
                        class="dynamic-delete-button"
                        type="minus"
                        :disabled="email.facebook.length === 1"
                        @click="removeDomain('facebook',facebook)"
                />
            </a-form-model-item>
            <a-form-model-item v-bind="formItemLayoutWithOutLabel"  >
<!--                <a-button type="dashed" style="width: 60%" @click="addDomain('facebook',1)">-->
<!--                    <a-icon type="plus" /> 添加邮箱-->
<!--                </a-button>-->
            </a-form-model-item>

            <a-form-model-item v-bind="formItemLayoutWithOutLabel">
                <a-button type="primary" html-type="submit" @click="submitForm('email')">
                    保存
                </a-button>
<!--                <a-button style="margin-left: 10px" @click="resetForm('email')">-->
<!--                    返回-->
<!--                </a-button>-->
            </a-form-model-item>


        </a-form-model>
        </a-spin>
    </div>
</template>

<script>
    import API from "./api";
    import {submitForm,validator} from '../../../utils/utils';
    let validator2=(rule, value, callback,errval)=> {
        let formerrname=rule.field
        if( errval!=""){
            callback(new Error(errval))
        } else if( value.indexOf("@") == -1&& value!=""){
            callback(new Error("请输入符合要求的邮箱"))
        } else{   callback();}
    }
    export default {
        name: "index",
        data(){

            return{
                formErr:{
                    facebook:[],
                    google:[]
                },
                validator2,
                spinning:true,
                formItemLayout: {
                    labelCol: {span: 4},
                    wrapperCol: {span: 16},
                },
                formItemLayoutWithOutLabel: {
                    wrapperCol: {
                        sm: { span: 16, offset: 4 },
                    },
                },
                email: {
                    google: [{
                        key: 1,
                        type:1,
                        email:""
                    },
                    ],
                    facebook:[{
                        key: 2,
                        type:2,
                        email:""
                    }]
                },
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/WebsiteDetection/PushMailbox"; //设置左侧导航2-2 active
        },
        mounted(){
            this.getFormData()
        },
        methods:{
            getFormData() {
                API.service.GET_EMAIL().then(res => {
                    this.email = res.data.data
                    if( this.email["facebook"].length<1){
                        this.email["facebook"]=[{
                            key: 2,
                            type:2,
                            email:""
                        }]
                    }
                    if( this.email["google"].length<1){
                        this.email["google"]=[{
                            key: 1,
                            type:1,
                            email:""
                        }]
                    }
                    this.spinning = false;
                })
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.email.google.map((item,index)=>{
                            item.type=1
                        })
                        this.email.facebook.map((item,index)=>{
                            item.type=2
                        })
                        submitForm(API.service.SET_EMAIL, this.email).then(res => {
                            if (res == true) {
                                this.getFormData()
                            } else {
                                let  formErr={
                                    facebook:[],
                                    google:[]
                                }
                                res.map((item, index) => {
                                    // console.log("00000000000",item.msg)
                                    // this.$message.error({ content:item.msg, key:"submitupdatable" , duration: 2 })
                                     // this.$message.error(item.msg)
                                    formErr[item.field][item.index]  = item.msg
                                })
                                this.formErr=formErr

                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            removeDomain(type,item) {
                let index = this.email[type].indexOf(item);
                if (index !== -1) {
                    this.email[type].splice(index, 1);
                }
            },
            addDomain(type,num) {
                  if(this.email[type].length>=5) {
                      this.$message.destroy()
                      this.$message.error('最多添加五个邮箱')
                      return
                  }
                this.email[type].push({
                 key: Date.now(),
                 type:num,
                 email:""
                });
            },

        }
    }
</script>

<style scoped>
.tit{font-weight: bold;margin-bottom:15px;font-size:16px}
</style>
